module.exports = __webpack_public_path__ + "img/fishes.94cf7f66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fishes.jpg
// module id = i1+f
// module chunks = 0